import { FormHeaderAndTabbedContent } from '@strata/react-form-header-and-content';
import { FormTitleLabel } from '@strata/react-label-value-pairs';
import { useLocation, useNavigate, useParams } from 'react-router';

import { AutomationsUpload } from 'pages/npiManagement/AutomationsUpload';
import { CapabilityFileUpload } from 'pages/npiManagement/CapabilityFileUpload';
import { GeneralInfoTab } from 'pages/npiManagement/GeneralInfoTab';
import { LddCapabilityTab } from 'pages/npiManagement/LddCapabilitiesTab';
import { LockManagementTab } from 'pages/npiManagement/LockManagementTab';
import { PayerCapabilityTab } from 'pages/npiManagement/payerCapabilities/PayerCapabilityTab';
import { StateCapabilityTab } from 'pages/npiManagement/StateCapabilitiesTab';
import { SupplierLocationsTab } from 'pages/npiManagement/SupplierLocationsTab';
import { useGet } from 'services/Http';

export const EditSupplier = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const goToSupplierList = () => navigate('/supplier-list');

    const { npi } = useParams();
    const supplier = useGet(npi ? `/reference/suppliers/${npi}` : undefined);
    const title = supplier?.organization_name
        ? `Edit Supplier: ${supplier.organization_name} (${npi})`
        : 'Edit Supplier';

    return (
        <FormHeaderAndTabbedContent
            rowOneContentHeader={<FormTitleLabel label={title} />}
            activeTab={location.hash.replace(/^#/, '').replace(/-/g, ' ')}
            onTabSelect={(tab) =>
                navigate({
                    ...location,
                    hash: tab.replace(/\s/g, '-').toLocaleLowerCase(),
                })
            }
            tabs={[
                {
                    title: 'General Info',
                    mainContent: <GeneralInfoTab onSecondaryButtonClick={goToSupplierList} />,
                },
                {
                    title: 'Supplier Locations',
                    mainContent: <SupplierLocationsTab />,
                },
                {
                    title: 'Lock Management',
                    mainContent: <LockManagementTab onSecondaryButtonClick={goToSupplierList} />,
                },
                {
                    title: 'Payer Capabilities',
                    mainContent: <PayerCapabilityTab />,
                },
                {
                    title: 'LDD Capabilities',
                    mainContent: <LddCapabilityTab onSecondaryButtonClick={goToSupplierList} />,
                },
                {
                    title: 'State Capabilities',
                    mainContent: <StateCapabilityTab onSecondaryButtonClick={goToSupplierList} />,
                },
                {
                    title: 'Capability Upload',
                    mainContent: <CapabilityFileUpload onSecondaryButtonClick={goToSupplierList} />,
                },
                {
                    title: 'Automations Upload',
                    mainContent: <AutomationsUpload onSecondaryButtonClick={goToSupplierList} />,
                },
            ]}
        />
    );
};
